export default "__VITE_ASSET__82b70bfd__"